import React from 'react'
import styled from 'styled-components'
import { navigate } from '@reach/router'
import View from './View'
import { getCurrentUser } from '../../services/auth'
import convenios from '../../services/convenios.json'
import planos from '../../services/planos.json'
import { device } from '../Breakpoints'
import { colors } from '../Colors'
import VejaTambem from '../VejaTambem'
import chevronDown from '../../icons/chevron-down-white.svg'
import chevronDownDisabled from '../../icons/chevron-down-grey.svg'

class Convenios extends React.Component {
  constructor(props) {
    super()
    this.state = {
      ...props,
    }
  }

  setPlanosReady(CodigoConvenio) {
    const filterPlanos = planos.ListaPlanos.filter(
      plano => plano.CodigoConvenio === CodigoConvenio
    )
    const newPlanos =
      Array.isArray(filterPlanos) && filterPlanos.length ? filterPlanos : ''
    this.setState({
      planosReady: true,
      apiPlanos: newPlanos,
    })
  }

  updateConvenio(event) {
    this.setState({
      convenio: event,
    })
  }

  render() {
    const { name } = getCurrentUser()
    const {
      apiConvenios = convenios.ListaPlanos,
      apiPlanos = '',
      planosReady = false,
      convenio = '',
    } = this.state

    const Container = styled.section`
      width: 100%;
      margin-bottom: 2em;
      .pageHeader {
        margin: auto;
        width: 100%;
        display: block;
      }
      section.center {
        margin-top: 2em;
        display: flex;
        justify-content: space-between;
        @media ${device.mobileL} {
          flex-wrap: wrap;
          padding: 2em;
        }
        .col1 {
          width: 55%;
          @media ${device.mobileL} {
            width: 100%;
          }
        }
        .col2 {
          width: 40%;
          form {
            padding-top: 2em;
            button {
              margin-top: 2em;
              @media ${device.mobileL} {
                margin: 2em auto 0;
              }
            }
          }
          @media ${device.mobileL} {
            width: 100%;
          }
        }
      }
    `
    const Form = styled.form`
      display: flex;
      flex-wrap: wrap;
      .half {
        width: 49%;
        margin-top: 8px;
        margin-right: 8px;
        box-sizing: border-box;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      textarea {
        display: block;
        padding: 10px;
        margin-top: -88px !important;
        width: 48% !important;
        height: 137px;
        resize: none;
        border: none;
        border-radius: 5px;
        font-family: 'Santral', Arial, Helvetica, sans-serif;
        font-size: 0.8em;
        ::placeholder {
          color: #b1b1b1;
        }
        @media ${device.mobileL} {
          margin-top: 8px !important;
          width: 100% !important;
        }
      }
      input,
      select {
        flex-direction: row;
        display: block;
        width: 100%;
        height: 40px;
        margin-top: 8px;
        font-family: 'Santral', Arial, Helvetica, sans-serif;
        font-size: 0.8em;
        border: none;
        border-radius: 4px;
        padding: 0 10px;
        box-sizing: border-box;
        color: #ffffff;
        background-color: #fa7271;
        box-shadow: 0px 5px 5px -4spx rgba(0, 0, 0, 0.2);
        background-image: url(${chevronDown});
        background-position: 413px 19px;
        background-size: auto;
        position: relative;
        ::placeholder {
          color: #b1b1b1;
        }
        :disabled {
          background-color: #e3e3e3;
          background-image: url(${chevronDownDisabled});
          color: #b1b1b1;
        }

        @media ${device.mobileL} {
          width: 100%;
        }
      }
      /**
        Target IE11
        */
      select::-ms-expand {
        display: none;
      }
      button {
        border: none;
        border-radius: 25px;
        height: 45px;
        width: 30%;
        color: white;
        text-transform: uppercase;
        background: ${colors.inputGradiente};
        font-family: 'Santral', Arial, Helvetica, sans-serif;
        margin-top: 10px;
        cursor: pointer;
        :hover {
          background: ${colors.verdeGradienteReverso};
        }
        @media ${device.mobileL} {
          width: 60%;
          margin: 1em auto;
        }
      }
    `
    return (
      <Container>
        <View>
          <div className="col1">
            <p>{`Prezada(o) ${name},`}</p>
            <p>
              Sabemos o quanto é importante conhecer a maternidade para ter a
              certeza da escolha certa nesse momento tão especial. Por isso,
              gestantes e acompanhantes são sempre bem-vindos!
            </p>
            <p>
              As visitas são previamente agendadas e acontecem de 2ª a 6ª feira,
              das 09h às 20h; e aos sábados, domingos e feriados, das 09h às
              16h.
            </p>
            <p>
              Ressaltamos que nem sempre temos quartos disponíveis para mostrar
              durante as visitas, pois dependemos da disponibilidade de leitos
              vagos no dia.
            </p>
          </div>
          <div className="col2">
            <Form>
              <select onChange={e => this.setPlanosReady(e.target.value)}>
                <option>Selecione seu convênio</option>
                {apiConvenios.map(convenio => (
                  <option
                    key={convenio.CodigoConvenio}
                    value={convenio.CodigoConvenio}
                  >
                    {convenio.NomeConvenio}
                  </option>
                ))}
              </select>

              <select
                onChange={e => this.updateConvenio(e.target.value)}
                disabled={planosReady ? '' : 'disabled'}
              >
                {apiPlanos !== '' ? (
                  apiPlanos.map(plano => (
                    <option key={plano.CodigoPlano} value={plano.NomePlano}>
                      {plano.NomePlano}
                    </option>
                  ))
                ) : (
                  <option key="1">Nenhum plano disponível</option>
                )}
              </select>

              <button
                type="button"
                className="button"
                onClick={() =>
                  navigate('/agendamento-de-visitas/calendario', {
                    state: { convenio },
                  })
                }
              >
                Próxima
              </button>
            </Form>
          </div>
        </View>
        <VejaTambem />
      </Container>
    )
  }
}

export default Convenios
